export default [
    // 非微能力教师成果认定
    {
        path: "/noabilityachievementrd",
        name: "AchievementConfirm",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityAchievementRd" */
                "../../views/personal/tearch/no_ability/NoAbilityAchievementRd.vue"
            ),
    },
    // 非微能力教师成果上传
    {
        path: "/noabilityachievementupload",
        name: "AchievementConfirm",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '上传成果'
                },
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityAchievementRd" */
                "../../views/personal/tearch/ability/AbilityUpLoad.vue"
            ),
    },
    // 非微能力教师证书
    {
        path: "/noabilitycertificate",
        name: "AbilityCertificate",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '证书'
                },
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityCertificate" */
                "../../views/personal/tearch/no_ability/NoAbilityCertificate.vue"
            ),
    },
    // 非微能力教师我的创建
    {
        path: "/noabilitycreate",
        name: "NoAbilityCreate",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我创建的'
                },
                {
                    path: '/',
                    name: '直播课'
                }
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityCreate" */
                "../../views/personal/tearch/no_ability/NoAbilityCreate.vue"
            ),
    },
    // 非微能力教师我的创建
    {
        path: "/noabilitycreatelb",
        name: "NoAbilityCreate",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我创建的'
                },
                {
                    path: '/',
                    name: '录播课'
                }
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityCreate" */
                "../../views/personal/tearch/no_ability/NoAbilityCreate.vue"
            ),
    },
    // 非微能力教师创建直播课
    {
        path: "/noabilitycreatelive",
        name: "NoAbilityCreate",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我创建的'
                },
                {
                    path: '/',
                    name: '创建直播课'
                }
            ]
        },
        
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityCreateLive" */
                "../../views/personal/tearch/no_ability/NoAbilityCreateLive.vue"
            ),
    },
    // 非微能力教师创建录播课
    {
        path: "/noabilitycreatelivelb",
        name: "NoAbilityCreate",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '我的课程'
                },
                {
                    path: '/',
                    name: '我创建的'
                },
                {
                    path: '/',
                    name: '创建录播课'
                }
            ]
        },
        
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityCreateLive" */
                "../../views/personal/tearch/no_ability/NoAbilityCreateLive.vue"
            ),
    },
    // 非微能力教师问卷调研
    {
        path: "/abilityquestionnaireinpuiry",
        name: "AbilityQuestionnaireInpuiry",
        meta: {
            breadCrumd: [{
                path: '/',
                name: '问卷调研'
            }]
        },
        component: () =>
            import(
                /* webpackChunkName: "AbilityQuestionnaireInpuiry" */
                "../../views/personal/tearch/ability/AbilityQuestionnaireInpuiry.vue"
            ),
    },

];

export const noAbilityOtherRoutes = [
    // 非微能力教师成果详情
    {
        path: "/noabilityachievementxq",
        name: "NoAbilityAchievementRd",
        meta: {
            breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                }
            ]
        },
        component: () =>
            import(
                /* webpackChunkName: "NoAbilityAchievementRd" */
                "../../views/personal/tearch/no_ability/NoAbilityAchievementXq.vue"
            ),
    },
]